import { useRoutes, Navigate } from "react-router-dom";

import {
  Embedded,
  Settings,
  SettingsExpanded,
  BuilderLayout,
  BuilderList,
  EditForm,
  Tab,
  Home,
} from "./embedded";
import { NotFound } from "./not-found";
import { settingsExpandedSegment } from "../components/embedded/settings/paths";
import { SubmissionV2 } from "../components/embedded/submission/submissionV2";

const RouteSelector = () =>
  useRoutes([
    {
      path: "/",
      element: <Navigate to="/embedded/home" replace />,
    },
    {
      path: "embedded",
      element: <Embedded />,
      children: [
        { path: "home", element: <Home /> },
        { path: "tab", element: <Tab /> },
        { path: "tab/:id", element: <SubmissionV2 /> },
        { path: "settings", element: <Settings /> },
        { path: settingsExpandedSegment, element: <SettingsExpanded /> },
        {
          path: "builder",
          element: <BuilderLayout />,
          children: [
            { path: "", element: <BuilderList /> },
            { path: ":id", element: <EditForm /> },
          ],
        },
        { path: "*", element: <NotFound /> },
      ],
    },
    { path: "*", element: <NotFound /> },
  ]);

export { RouteSelector };
